/* STRYD restyle of the Klaviyo welcome pop-up ("Email & SMS Popup", form WY7zTp) and its teaser.
   Klaviyo still renders the form and collects sign-ups; this only swaps wording and the logo.
   Copy: copy/klaviyo-welcome-popup-review-sarah-2026-10.md. Styles: assets/stryd-brand.css (.stryd-kpop).
   Blocks are found by role (the dialog holding the email field, then its text blocks by content and
   order), not by Klaviyo's rich-text ids: those ids change every time the form is edited in Klaviyo
   (that silently broke the restyle on 2026-10-16). */
(function () {
  'use strict';
  var COPY = {
    head: '<p class="sk-eyebrow">Built to move. Made to perform.</p><p class="sk-head">10% off your first order</p>',
    /* only shown when the offers engine is in live mode, so the pop-up never promises socks the cart won't add */
    /* 2026-10-24: socks don't qualify for the gift, so "every apparel order" (Copy Boss, matches the top bar) */
    socks: '<p class="sk-sub">Plus a gift with every apparel order: a pair of our Performance Crew Socks.</p>',
    list: '<p class="sk-list">First look at new drops<span class="sk-dot"></span>Members-only offers</p>',
    fine: '<p class="sk-fine">Your code arrives by email. One use per customer; it doesn’t combine with other offers. Unsubscribe any time. ' +
          '<a href="/policies/privacy-policy">Privacy policy</a></p>',
    submit: 'Email my 10% code',
    decline: 'No thanks',
    firstName: 'First name (optional)',
    teaser: '10% off your first order',
    label: '10% off your first order'
  };
  var LOGO = window.STRYD_KLAVIYO_LOGO || '';

  function setHtml(el, html) {
    if (el && el.getAttribute('data-sk') !== '1') { el.innerHTML = html; el.setAttribute('data-sk', '1'); }
  }
  function setButtonText(btn, text) {
    if (!btn || btn.textContent.trim() === text) return;
    var node = btn.firstChild;
    while (node && node.nodeType !== 3) node = node.nextSibling;
    if (node) node.nodeValue = text; else btn.textContent = text;
  }

  COPY.embedSubmit = 'Email my 10% code';
  var EMBED_TEXT = [
    [/^(\s*10% )Off( your first purchase)/, '$1off$2'],
    [/(Early access to )New( collections)/, '$1new$2'],
    [/^(\s*)Member only offers/, '$1Members-only offers']
  ];

  /* where Klaviyo's on-site pop-up, teaser tab and forms live */
  var KL_SCOPE = '.needsclick, .klaviyo-form, [class*="kl-teaser"], [class*="klaviyo-form-"]';
  var teaserDone = false, lastFullScan = 0;

  var DECLINE = /^no,?\s*thanks?$/i;
  var FINE = /by signing up|unsubscribe|privacy|terms of service/i;

  function apply() {
    /* the welcome pop-up = a Klaviyo form inside a dialog with an email field (the embedded footer
       form is not in a dialog, so it is never touched) */
    var forms = document.querySelectorAll('[role="dialog"] form.klaviyo-form');
    for (var f = 0; f < forms.length; f++) {
      var form = forms[f];
      if (!form.querySelector('input[type="email"]')) continue;
      var dlg = form.closest('[role="dialog"]');
      if (dlg && !dlg.classList.contains('stryd-kpop')) { dlg.classList.add('stryd-kpop'); dlg.setAttribute('aria-label', COPY.label); }

      /* text blocks in order: the fine print is the one with the legal wording, the first other block
         is the headline, the next is the perks line */
      var blocks = Array.prototype.slice.call(form.querySelectorAll('[id^="rich-text-"]'));
      var fine = null, rest = [];
      blocks.forEach(function (b) {
        if (!fine && (b.getAttribute('data-sk-role') === 'fine' || FINE.test(b.textContent))) fine = b; else rest.push(b);
      });
      var head = rest[0] || null, list = rest[1] || null;
      if (head) head.setAttribute('data-sk-role', 'head');
      if (list) list.setAttribute('data-sk-role', 'list');
      if (fine) fine.setAttribute('data-sk-role', 'fine');

      var offers = window.STRYD_OFFERS;
      var socksLive = !!(offers && offers.mode === 'live' && offers.gift);
      setHtml(head, COPY.head + (socksLive ? COPY.socks : ''));
      setHtml(list, COPY.list);
      setHtml(fine, COPY.fine);

      /* First name is optional in the Klaviyo form settings; say so on screen */
      var fn = form.querySelector('input[id^="first_name_"]');
      if (fn && fn.placeholder !== COPY.firstName) { fn.placeholder = COPY.firstName; fn.setAttribute('aria-label', COPY.firstName); }
      form.querySelectorAll('button.klaviyo-form-button').forEach(function (b) {
        if (DECLINE.test(b.textContent.trim())) { setButtonText(b, COPY.decline); b.classList.add('sk-decline'); }
        else { setButtonText(b, COPY.submit); b.classList.add('sk-submit'); }
      });
    }
    /* any open step of this pop-up (sign-up or success): the logo is the first image inside the form;
       swap the charcoal file for the real white wordmark so it reads on black */
    document.querySelectorAll('.stryd-kpop form.klaviyo-form').forEach(function (f) {
      var img = f.querySelector('.klaviyo-form-image img');
      if (LOGO && img && img.getAttribute('data-sk') !== '1') {
        img.src = LOGO; img.removeAttribute('srcset'); img.setAttribute('data-sk', '1'); img.alt = 'STRYD Performance';
        img.classList.add('sk-logo');
      }
    });
    /* embedded homepage sign-up form (X65bEf, not in a dialog): button label + consistent capitals in the
       perks lines, swapped text node by text node so Klaviyo's inline styles stay put. "unlock" kept at the
       user's request. Copy: copy/homepage-signup-button-krystal-2026-10-17.md */
    document.querySelectorAll('.klaviyo-form-X65bEf form.klaviyo-form').forEach(function (form) {
      if (form.closest('[role="dialog"]')) return;
      var walker = document.createTreeWalker(form, NodeFilter.SHOW_TEXT, null), n;
      while ((n = walker.nextNode())) {
        for (var e = 0; e < EMBED_TEXT.length; e++) {
          if (EMBED_TEXT[e][0].test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(EMBED_TEXT[e][0], EMBED_TEXT[e][1]);
        }
      }
      form.querySelectorAll('button.klaviyo-form-button').forEach(function (b) { setButtonText(b, COPY.embedSubmit); });
    });

    /* teaser tab: look inside Klaviyo's own elements only. A whole-page scan ran on every page change and
       cost up to ~1.8 s of phone CPU on product pages (2026-10-24); it stays only as a fallback, at most every
       2 s, until the tab has been found once, in case Klaviyo changes its markup. */
    var spans = document.querySelectorAll(KL_SCOPE.split(', ').map(function (s) { return s + ' *'; }).join(', '));
    if (!teaserDone && !spans.length && Date.now() - lastFullScan > 2000) {
      lastFullScan = Date.now();
      spans = document.querySelectorAll('body > div *');
    }
    for (var i = 0; i < spans.length; i++) {
      var s = spans[i];
      if (s.children.length === 0 && /^unlock 10% off$/i.test(s.textContent.trim())) {
        s.textContent = COPY.teaser;
        teaserDone = true;
        var tab = s.closest('[role="button"], button') || s.parentElement;
        if (tab) {
          tab.classList.add('stryd-kteaser');
          /* Klaviyo wraps the tab in a framed container; mark the wrappers so the frame can be removed */
          var w = tab.parentElement;
          for (var k = 0; k < 2 && w && w !== document.body; k++) { w.classList.add('stryd-kteaser-wrap'); w = w.parentElement; }
        }
      }
    }
  }

  /* Only re-run when something changes inside Klaviyo's pop-up, teaser or forms (or Klaviyo adds one).
     Carousels, reviews, the cart drawer and size charts change the page constantly; reacting to all of that
     made this script one of the heaviest on product pages. */
  // a change happened inside Klaviyo's markup
  function insideKlaviyo(n) {
    var el = n && (n.nodeType === 1 ? n : n.parentElement);
    return !!(el && el.closest && el.closest(KL_SCOPE));
  }
  // a newly added element is, or carries, Klaviyo's markup (e.g. the pop-up being inserted into <body>)
  function addsKlaviyo(n) {
    return n.nodeType === 1 && (n.matches(KL_SCOPE) || !!n.querySelector(KL_SCOPE));
  }
  var queued = false;
  new MutationObserver(function (records) {
    if (queued) return;
    var hit = false;
    for (var r = 0; r < records.length && !hit; r++) {
      if (insideKlaviyo(records[r].target)) { hit = true; break; }
      var added = records[r].addedNodes;
      for (var a = 0; a < added.length; a++) { if (addsKlaviyo(added[a])) { hit = true; break; } }
    }
    if (!hit) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; apply(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  apply();

  /* Top bar "New here? Get 10% off your first order": open this pop-up where the shopper is (Klaviyo custom trigger)
     instead of sending them to /pages/sign-up-to-our-emails. The 30 s / second-page timing set in Klaviyo is unchanged.
     If the pop-up hasn't appeared after 1.5 s (Klaviyo blocked or not loaded), fall back to the sign-up page. 2026-10-18. */
  var FORM_ID = 'WY7zTp';
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-stryd-signup], a[href*="/pages/sign-up-to-our-emails"]');
    /* top bar links, plus any link marked data-stryd-signup (sections/stryd-signup-link.liquid on the homepage) */
    if (!a || !(a.hasAttribute('data-stryd-signup') || a.closest('.announcement-bar, .utility-bar, .announcement-bar-section'))) return;
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', FORM_ID]);
    setTimeout(function () {
      if (!document.querySelector('[data-kl-scroll-locking-modal], .stryd-kpop')) location.href = a.href;
    }, 1500);
  });
})();
